<template>
	<div>
		<v-dialog
			max-width="600px"
			fullscreen
			hide-overlay
			v-model="showDialog"
		>
			<div
				class="header"
				:style="{
					backgroundColor: themeInputColor,
					position: 'fixed'
				}"
			>
				<v-btn
					fab
					flat
					icon
					class="top-left-align pa-0 ma-0 z-index--2"
					@click="goBack"
				>
					<v-icon color="#FFF">arrow_back</v-icon>
				</v-btn>
				Task/Review Section
			</div>
			<div class="container" v-if="processStep === 1">
				<div v-if="selectedRetailer.remarks" class="text-xs-center">
					Reason For Rejection: {{ selectedRetailer.remarks }}
				</div>
				<div class="addressVerification">Address Verification</div>
				<div class="proofDocument">
					Address Proof Documents Submitted
				</div>
				<v-card class="pdfCard" v-if="retailerData.addressProof">
					<div class="ma-2">
						{{
							retailerData.addressProof[0].docType === "GST"
								? "GST Certificate"
								: "Current Address Proof"
						}}
					</div>
					<pdf
						:src="{
							url: retailerData.addressProof[0].url
						}"
						:key="retailerData.addressProof[0].url"
						:resize="true"
						:scale.sync="scale"
						style="width:40%;"
					>
						<template slot="loading">
							loading content here...
						</template>
					</pdf>
					<v-layout class="white" style="justify-content:end">
						<v-btn @click="downloadPdf" color="success"
							>Download</v-btn
						>
					</v-layout>
				</v-card>
				<div class="proofDocument mb-2">Address Submitted</div>
				<v-card class="addressBox font-weight-bold"
					><div>{{ retailerData.address }}</div>
					<div>{{ retailerData.state }}, {{ retailerData.city }}</div>
					<div>Pincode: {{ retailerData.pincode }}</div></v-card
				>
				<div class="ma-2">
					<v-btn color="error" @click="updateRetailerStatus(REJECTED)"
						>Reject</v-btn
					>
					<v-btn color="primary" @click="processStep = 2"
						>Approve</v-btn
					>
				</div>
			</div>
			<div class="container" v-if="processStep === 2">
				<div class="addressVerification">Photo Verification</div>
				<div class="proofDocument mb-2" style="font-size:12px">
					Business/Shop Photo Submitted by Retailer for Reference
				</div>
				<img
					:src="retailerData.shopImage"
					alt
					class="imageSize"
					v-if="retailerData.shopImage"
				/>
				<div class="addressVerification mb-2">
					Location Verification
				</div>
				<v-btn
					@click="
						openGoogleMap(
							`https://maps.google.com?q=${retailerData.latitude},${retailerData.longitude}`
						)
					"
					>View location on Maps
				</v-btn>
				<v-card
					:style="
						isInsideRange
							? { background: '#52C41A' }
							: { background: '#FAAD14' }
					"
					class="alignInColumn white--text font-weight-bold pa-2 mt-2"
					v-if="showLocationRangeStatus"
				>
					<div style="font-size:16px">
						{{ isInsideRange ? "Correct" : "Incorrect" }} Location
					</div>
					<div>
						{{
							isInsideRange
								? `You are within 50 meters of location. Click “${
										isJeet11Executive ||
										retailerData.shopStatus === ACCEPTED
											? "Mark Visit"
											: "Start Verification"
								  }” to start the process.`
								: "You are not within 50 meters of the shop location. Please go to location and try again."
						}}
					</div>
					<div
						style="align-self:end"
						v-if="!isInsideRange"
						@click="updateRetailerStatus(REJECTED)"
					>
						<v-btn color="error">Reject Retailer Location</v-btn>
					</div>
				</v-card>
				<div style="display:flex;margin:1rem 0">
					<v-btn @click="verifyLocation">Check My Location</v-btn>
					<v-btn
						color="primary"
						@click="processStep = 3"
						:disabled="!isInsideRange"
						>{{
							isJeet11Executive ||
							retailerData.shopStatus === ACCEPTED
								? "Mark Visit"
								: "Start Verification"
						}}</v-btn
					>
				</div>
			</div>
			<div class="alignInColumn container" v-if="processStep == 3">
				<div class="font-weight-bold mb-2" style="font-size:14px">
					Step 1: Upload a Front View Photo of Shop/Business
				</div>
				<div style="font-size:12px">
					*Photo should match the photo submitted by Retailer
				</div>
				<img
					:src="tsmShopImage"
					alt
					class="imageSize"
					v-if="tsmShopImage"
				/>
				<v-layout class="pa-3" align-center>
					<v-flex xs6 sm4 md4
						><input
							ref="input"
							type="file"
							@change="onFileChange"
							accept="image/*"
							capture="camera"
							style="display:none"
						/>
						<v-btn @click="$refs.input.click()">Take Photo</v-btn>
					</v-flex>
				</v-layout>
				<div v-if="retailerData.shopStatus !== ACCEPTED">
					<div
						class="font-weight-bold mb-2"
						:style="{
							fontSize: '14px',
							color: !tsmShopImage ? '#00000073' : ''
						}"
					>
						Step 2: OTP Verification
					</div>
					<v-btn
						color="primary"
						:disabled="!tsmShopImage"
						@click="sendOTP(retailerData.userId)"
						>Request OTP</v-btn
					>
				</div>
				<div v-else>
					<v-btn
						color="primary"
						:disabled="!tsmShopImage"
						@click="retailVisit"
						>Submit</v-btn
					>
				</div>
				<v-dialog v-model="showOtpPopup" persistent max-width="400px">
					<v-card class="px-4 py-2">
						<v-card-title class="px-0">
							<span class="title grey-lighten-1--text"
								>Verify OTP</span
							>
							<v-btn
								icon
								class="top-right-align"
								@click="showOtpPopup = false"
							>
								<v-icon>close</v-icon>
							</v-btn>
						</v-card-title>
						<v-card-text class="px-0">
							<v-text-field
								label="Enter OTP"
								v-model="otp"
								class="pr-4"
								autofocus
								@change="val => (otp = val)"
							></v-text-field>
							<div class="justify-end mt-3 verCenteredChild">
								<v-btn
									flat
									color="blue lighten-1"
									class="my-0 mx-4"
									@click="sendOTP"
									:loading="isLoading"
								>
									<v-icon left>refresh</v-icon>Resend OTP
								</v-btn>
								<v-btn
									class="white--text"
									:color="themeInputColor"
									:loading="isLoading"
									@click="updateRetailerStatus(ACCEPTED, otp)"
									>Verify</v-btn
								>
							</div>
						</v-card-text>
					</v-card>
				</v-dialog>
			</div>
		</v-dialog>
		<div v-if="!showDialog">
			<div class="px-2">Search Retailers</div>
			<v-text-field
				outlined
				v-model="searchPhoneNo"
				placeholder="Enter Phone Number"
				@change="updateSearchValue"
				type="number"
				class="px-2"
			></v-text-field>
			<div v-if="isJeet11Executive && splitIndex" class="px-2 mb-2">
				Today's Task
			</div>
			<div
				v-for="(item, index) in retailersVisitList.filter(
					item =>
						`${item.phoneNo}`.includes(searchPhoneNo) &&
						(!isJeet11Executive || item.shopStatus === ACCEPTED)
				)"
				:key="item.userId"
			>
				<div
					v-if="isJeet11Executive && splitIndex === index"
					class="px-2 mb-2"
				>
					Other Retailers
				</div>
				<v-card
					style="display:flex;justify-content: space-around;"
					class="mb-2"
				>
					<div class="pa-2 alignInColumn">
						<div class="font-weight-bold mb-2">
							{{ item.retailerName || "-" }}
							<v-tooltip
								right
								v-if="
									item.visit &&
										item.visit.status === PENDING &&
										item.visit.purposeOfVisit &&
										isJeet11Executive
								"
							>
								<template v-slot:activator="{ on }">
									<v-icon
										color="primary"
										dark
										v-on="on"
										style="cursor:pointer"
										size="20"
										>info</v-icon
									>
								</template>
								<span>{{ item.visit.purposeOfVisit }}</span>
							</v-tooltip>
						</div>
						<div>{{ item.phoneNo || "-" }}</div>
					</div>
					<div class="pa-2">
						<v-btn
							color="primary"
							@click="showRetailer(item, item.shopStatus)"
							style="min-width: 150px;"
							:disabled="
								item.shopStatus === PENDING_TO_RBM ||
									(item.shopStatus === ACCEPTED &&
										retailersLastVisitedTime[
											`${userId}/${item.userId}`
										] === new Date().toDateString()) ||
									(item.shopStatus === REJECTED &&
										!item.remarks)
							"
							>{{ buttonContent(item) }}</v-btn
						>
					</div>
				</v-card>
			</div>
			<div style="display: flex;justify-content: center" class="mb-2">
				<v-icon
					v-if="offset"
					color="#000"
					style="cursor: pointer"
					@click="changeOffset('dec')"
					>chevron_left</v-icon
				><v-icon
					v-if="retailersVisitList.length === limit"
					color="#000"
					style="cursor: pointer"
					@click="changeOffset('inc')"
					>chevron_right</v-icon
				>
			</div>
		</div>
		<div v-if="isLoading" class="overlay">
			<v-progress-circular :indeterminate="true"></v-progress-circular>
		</div>
		<v-dialog v-model="showPopup" persistent max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline">Allow Location Access</span>
				</v-card-title>
				<div class="text-xs-center" style="font-size:large;">
					Please enable location access
				</div>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="error" flat @click="showPopup = false"
						>Close</v-btn
					>
				</v-card-actions>
			</v-card></v-dialog
		>
		<v-dialog
			v-model="showRejectedPopup"
			v-if="selectedRetailer.remarks"
			persistent
			max-width="600px"
		>
			<v-card>
				<v-card-title>
					<span class="headline">Reason for Rejection</span>
				</v-card-title>
				<div class="text-xs-center" style="font-size:large;">
					{{ selectedRetailer.remarks }}
				</div>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="error" flat @click="showRejectedPopup = false"
						>Close</v-btn
					>
				</v-card-actions>
			</v-card></v-dialog
		>
	</div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import pdf from "pdfvuer";
import { THEME_INPUT_COLOUR } from "../constants";
import {
	RETAILERS_VISIT_LIST,
	FETCH_JEET11_PARTNER_WALLET_DETAILS,
	UPDATE_RETAILER_STATUS,
	GET_RETAILER_OTP,
	UPLOAD_MEDIA_TO_SERVER,
	RETAIL_VISIT
} from "../../store/action-types";
import { __fileDownload, getDistanceBetweenPoints } from "../../utils";

let filePayload = null;

export default {
	name: "TaskReviewSection",
	data: () => ({
		isLoading: false,
		showDialog: false,
		themeInputColor: THEME_INPUT_COLOUR,
		limit: 100,
		offset: 0,
		retailersVisitList: [],
		searchPhoneNo: "",
		ACCEPTED: "accepted",
		REJECTED: "rejected",
		PENDING: "pending",
		PENDING_TO_RBM: "pendingToRbm",
		selectedRetailer: {},
		retailerData: {},
		processStep: 1,
		scale: "page-width",
		showPopup: false,
		currentPosition: {},
		isInsideRange: false,
		showLocationRangeStatus: false,
		tsmShopImage: "",
		showOtpPopup: false,
		otp: "",
		showRejectedPopup: false,
		retailersLastVisitedTime: {},
		splitIndex: -1
	}),
	mounted() {
		this.fetchRetailersVisitList();
		window.addEventListener("message", this.onMessageHandler);
	},
	beforeUnmount() {
		window.removeEventListener("message", this.onMessageHandler);
	},
	components: {
		pdf
	},
	computed: {
		...mapGetters({
			isJeet11Executive: "auth/isJeet11Executive"
		}),
		...mapState({
			userId: state => state.auth.USERID
		})
	},
	methods: {
		fetchRetailersVisitList() {
			this.isLoading = true;
			const dateValue = new Date().toLocaleDateString().split("/");
			const currDate = `${dateValue[2]}-${dateValue[1]}-${dateValue[0]}`;
			this.$store
				.dispatch(RETAILERS_VISIT_LIST.dispatch, {
					limit: this.limit,
					offset: this.offset,
					userId: this.userId,
					date: currDate
				})
				.then(data => {
					this.retailersVisitList = data.retailers || [];
					this.retailersVisitList.sort((a, b) =>
						a.visit && a.visit.status === this.PENDING
							? -1
							: b.visit && b.visit.status === this.PENDING
							? 1
							: new Date(
									a.lastVisited ? a.lastVisited : new Date()
							  ).getTime() -
							  new Date(
									b.lastVisited ? b.lastVisited : new Date()
							  ).getTime()
					);
					let i = 0;
					while (i < this.retailersVisitList.length) {
						if (
							!this.retailersVisitList[i].visit ||
							this.retailersVisitList[i].visit.status !==
								this.PENDING
						) {
							this.splitIndex = i;
							break;
						}
						i++;
					}
					this.retailersLastVisitedTime =
						JSON.parse(
							localStorage.getItem("retailersLastVisitedTime")
						) || {};
				})
				.catch(err => console.log(err))
				.finally(() => {
					this.isLoading = false;
				});
		},
		getRetailerData(phoneNo) {
			this.isLoading = true;
			this.$store
				.dispatch(FETCH_JEET11_PARTNER_WALLET_DETAILS.dispatch, {
					p: phoneNo,
					isSchemeRequired: true
				})
				.then(data => {
					this.retailerData = data || {};
				})
				.catch(err => console.log(err))
				.finally(() => {
					this.isLoading = false;
				});
		},
		updateRetailerStatus(shopStatus, otp) {
			this.isLoading = true;
			const payload =
				shopStatus === this.REJECTED
					? { userId: this.selectedRetailer.userId, shopStatus }
					: {
							userId: this.selectedRetailer.userId,
							shopStatus,
							tsmShopImage: this.tsmShopImage,
							otp
					  };
			this.$store
				.dispatch(UPDATE_RETAILER_STATUS.dispatch, payload)
				.then(() => {
					this.showDialog = false;
					this.reInitializeValue();
					this.fetchRetailersVisitList();
					this.searchPhoneNo = "";
					this.processStep = 1;
				})
				.catch(err => console.log(err))
				.finally(() => {
					this.isLoading = false;
				});
		},
		retailVisit() {
			this.isLoading = true;
			this.$store
				.dispatch(RETAIL_VISIT.dispatch, {
					retailerId: this.selectedRetailer.userId,
					shopImage: this.tsmShopImage,
					latitude: this.currentPosition.lat,
					longitude: this.currentPosition.lng,
					status: "visited"
				})
				.then(statusCode => {
					if (statusCode === 200) {
						this.showDialog = false;
						this.fetchRetailersVisitList();
						this.searchPhoneNo = "";
						this.processStep = 1;
						this.retailersLastVisitedTime[
							`${this.userId}/${this.selectedRetailer.userId}`
						] = new Date().toDateString();
						localStorage.setItem(
							"retailersLastVisitedTime",
							JSON.stringify(this.retailersLastVisitedTime)
						);
						this.reInitializeValue();
					}
				})
				.catch(err => console.log(err))
				.finally(() => {
					this.isLoading = false;
				});
		},
		sendOTP(userId) {
			this.isLoading = true;
			this.$store
				.dispatch(GET_RETAILER_OTP.dispatch, { userId })
				.then(() => {
					this.showOtpPopup = true;
				})
				.catch(err => console.log(err))
				.finally(() => {
					this.isLoading = false;
				});
		},
		downloadPdf() {
			__fileDownload(
				this.retailerData.addressProof
					? this.retailerData.addressProof[0].url
					: ""
			);
		},
		updateSearchValue(val) {
			this.searchPhoneNo = val;
		},
		buttonContent(item) {
			const isAlreadyVisited =
				this.retailersLastVisitedTime[
					`${this.userId}/${item.userId}`
				] === new Date().toDateString();
			if (item.shopStatus === this.ACCEPTED && !isAlreadyVisited)
				return "Visit Location";
			else if (item.shopStatus === this.ACCEPTED && isAlreadyVisited)
				return "Visited";
			else if (item.shopStatus === this.PENDING_TO_RBM) return "Pending";
			else if (item.shopStatus === this.REJECTED) return "Rejected";
			return "Verify Location";
		},
		showRetailer(data, status) {
			this.selectedRetailer = data;
			if (status === this.REJECTED) {
				this.showRejectedPopup = true;
				return;
			}
			this.showDialog = true;
			this.processStep =
				this.isJeet11Executive || status === this.ACCEPTED ? 2 : 1;
			this.getRetailerData(data.phoneNo);
		},
		goBack() {
			this.processStep =
				this.isJeet11Executive && this.processStep === 2
					? 0
					: this.processStep - 1;
			if (
				this.selectedRetailer.shopStatus === this.ACCEPTED &&
				this.processStep === 1
			)
				this.processStep--;
			this.showDialog = !!this.processStep;
			if (!this.showDialog) {
				this.reInitializeValue();
			}
		},
		reInitializeValue() {
			this.selectedRetailer = {};
			this.retailerData = {};
			this.currentPosition = {};
			this.isInsideRange = false;
			this.showLocationRangeStatus = false;
			this.tsmShopImage = "";
			this.showOtpPopup = false;
			this.otp = "";
			this.showRejectedPopup = false;
		},
		verifyLocation() {
			if (window.ReactNativeWebView) {
				window.ReactNativeWebView.postMessage(
					JSON.stringify({
						fetchLocation: true
					})
				);
				this.isLoading = true;
			} else {
				navigator.permissions
					.query({ name: "geolocation" })
					.then(result => {
						if (result.state === "granted") {
							this.setCurrentLocation();
						} else {
							this.showPopup = true;
						}
						result.onchange = () => {
							if (result.state === "granted") {
								this.setCurrentLocation();
							}
						};
					});
			}
		},
		setCurrentLocation() {
			this.isLoading = true;
			navigator.geolocation.getCurrentPosition(position => {
				this.currentPosition = {
					lat: position.coords.latitude,
					lng: position.coords.longitude
				};
				this.isLoading = false;
				const distance = getDistanceBetweenPoints(
					this.currentPosition.lat,
					this.currentPosition.lng,
					this.retailerData.latitude,
					this.retailerData.longitude
				);
				this.isInsideRange = distance < 50;
				this.showLocationRangeStatus = true;
			});
		},
		onFileChange(e) {
			const files = e.target.files || e.dataTransfer.files;
			if (!files.length) return;
			filePayload = files[0];
			this.uploadFile();
		},
		uploadFile() {
			this.isLoading = true;
			this.$store
				.dispatch(UPLOAD_MEDIA_TO_SERVER.dispatch, {
					key: "tsmShopImage",
					file: filePayload
				})
				.then(data => {
					this.tsmShopImage = data.fileUrl;
				})
				.finally(() => (this.isLoading = false));
		},
		changeOffset(updateValue) {
			if (updateValue === "inc") this.offset += this.limit;
			else this.offset -= this.limit;
			this.fetchRetailersVisitList();
		},
		onMessageHandler(e) {
			const { data } = e;
			try {
				const { type, payload } = data;
				if (type === "LOCATION") {
					const { latitude, longitude } = payload;
					if (latitude !== "FAILED" && latitude !== "NO_PERMISSION") {
						this.currentPosition = {
							lat: latitude,
							lng: longitude
						};
						const distance = getDistanceBetweenPoints(
							this.currentPosition.lat,
							this.currentPosition.lng,
							this.retailerData.latitude,
							this.retailerData.longitude
						);
						this.isInsideRange = distance < 50;
						this.showLocationRangeStatus = true;
					} else {
						this.showPopup = true;
					}
				}
			} catch (error) {
				console.log("error: ", error);
			} finally {
				this.isLoading = false;
			}
		},
		openGoogleMap(action) {
			if (window.ReactNativeWebView) {
				window.ReactNativeWebView.postMessage(
					JSON.stringify({
						openExternalLink: { action }
					})
				);
			} else {
				window.open(action, "_blank");
			}
		}
	}
};
</script>

<style scoped>
.container {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 65px;
}
.addressVerification {
	font-weight: 500;
	font-size: 20px;
	color: #00000073;
	margin: 1rem;
	margin-top: 0.5rem;
}
.proofDocument {
	font-weight: 400;
	font-size: 16px;
	color: #00000073;
}
.pdfCard {
	background: #fafafa;
	margin: 1rem 0rem;
	padding: 10px 20px;
}
.addressBox {
	background: rgb(245, 245, 245);
	width: 100%;
	padding: 0.5rem;
	display: flex;
	flex-direction: column;
}
.alignInColumn {
	display: flex;
	flex-direction: column;
}
.imageSize {
	min-width: 300px;
	height: 300px;
}
</style>
